<script setup>
import { Handle, Position } from '@vue-flow/core';
import { NODE_TYPES } from '../../constants';
import FlowNodeCard from './FlowNodeCard.vue';

defineProps({ selected: { type: Boolean, default: false } });
const meta = NODE_TYPES.hubsoft_consultar_planos;
</script>

<template>
  <FlowNodeCard :icon="meta.icon" :color="meta.color" :title="meta.label" :selected="selected">
    <Handle type="target" :position="Position.Left" />
    <p>Busca o catálogo real de planos e preços no HubSoft e manda o resultado.</p>
    <Handle type="source" :position="Position.Right" />
  </FlowNodeCard>
</template>
